import React from "react";
import { Box, Link, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
// White "REGODIT" wordmark (icon + name); shown in ink with a filter.
import RegoditWordmark from "../../../Assets/Images/regoditWordmark.webp";
import { PAGE_MAX_WIDTH } from "../styles/publicStyles";

// Regodit's place on a customer's Trust Center: a quiet "Powered by Regodit"
// at the bottom (the top belongs to the company). Also where the security
// contact and the company's own legal links sit.
const TrustFooter = ({ company }) => {
  const theme = useTheme();
  const t = theme.trust;
  const links = [
    company?.securityEmail && {
      key: "security",
      href: `mailto:${company.securityEmail}`,
      label: "Report a security issue",
    },
    company?.privacyUrl && { key: "privacy", href: company.privacyUrl, label: "Privacy policy" },
    company?.termsUrl && { key: "terms", href: company.termsUrl, label: "Terms of service" },
  ].filter(Boolean);

  return (
    // mt auto: at the bottom of the screen on a short page (the page is a
    // flex column), right after the content otherwise.
    <Box component="footer" sx={{ mt: "auto", borderTop: `1px solid ${t.line}` }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
        spacing={2}
        sx={{
          maxWidth: PAGE_MAX_WIDTH,
          mx: "auto",
          px: { xs: 2, sm: 3, lg: 4 },
          py: 3,
          boxSizing: "border-box",
        }}
      >
        <Link
          href="https://regodit.ai"
          target="_blank"
          rel="noopener"
          underline="none"
          aria-label="Powered by Regodit"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            color: t.muted,
            fontSize: 13,
            "&:hover": { color: t.ink, "& img": { opacity: 1 } },
            "&:focus-visible": { outline: `2px solid ${t.accent}`, outlineOffset: 2, borderRadius: "6px" },
          }}
        >
          <span>Powered by</span>
          <Box
            component="img"
            src={RegoditWordmark}
            alt=""
            sx={{
              height: 16,
              width: "auto",
              display: "block",
              // The file is white; brightness(0) makes it black, and the
              // opacity softens it to the page's ink.
              filter: "brightness(0)",
              opacity: 0.82,
              transition: `opacity 160ms ${t.ease}`,
            }}
          />
        </Link>
        {links.length > 0 && (
          <Stack direction="row" useFlexGap spacing={2.5} sx={{ flexWrap: "wrap" }}>
            {links.map((link) => (
              <Link
                key={link.key}
                href={link.href}
                target={link.key === "security" ? undefined : "_blank"}
                rel="noopener"
                underline="hover"
                sx={{ fontSize: 13, color: t.muted, "&:hover": { color: t.ink } }}
              >
                {link.label}
              </Link>
            ))}
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default TrustFooter;
